import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.50033 18.0003C5.50033 11.0968 11.0968 5.50033 18.0003 5.50033C24.9039 5.50033 30.5003 11.0968 30.5003 18.0003C30.5003 24.9039 24.9039 30.5003 18.0003 30.5003C11.0968 30.5003 5.50033 24.9039 5.50033 18.0003Z",
				stroke: "#079455",
				strokeWidth: 1.66667
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .1,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1.33333 18C1.33333 8.79525 8.79525 1.33333 18 1.33333C27.2047 1.33333 34.6667 8.79525 34.6667 18C34.6667 27.2047 27.2047 34.6667 18 34.6667C8.79525 34.6667 1.33333 27.2047 1.33333 18Z",
				stroke: "#079455",
				strokeWidth: 1.66667
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6663 13L15.4997 22.1667L11.333 18",
			stroke: "#079455",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAlertSuccess;
